import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

export default class ModalContainer extends React.Component {
  static propTypes = {
    onLoad: PropTypes.func.isRequired,
    onUnload: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    const { onLoad } = this.props

    document.body.appendChild(this.el)
    this.el.classList.add('checkcherry__widget')
    this.el.classList.add('checkcherry__widget__modal__container')

    onLoad(this.el)
  }

  componentWillUnmount() {
    const { onUnload } = this.props
    onUnload()
    document.body.removeChild(this.el)
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el
    )
  }
}
